import React, { useMemo } from 'react';
import { SelectOption } from 'global';
import { grey } from '@mui/material/colors';
import { SelectField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { Box, Button, Stack, Typography } from '@mui/material';

import { LenderDeskingPanelFormValues, LenderDeskingSections } from '../../../types';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { CreditSubmission } from '@trnsact/trnsact-shared-types';
import { decisionCodeToStatus } from 'modules/creditSubmission/constants';

const decisionOptions: SelectOption[] = [
  { value: '803370002', label: 'Declined' },
  { value: '803370003', label: 'Approved' },
  { value: '803370004', label: 'Pre-Approved' },
  { value: '803370000', label: 'Awaiting Review' },
  { value: '803370001', label: 'Requested Additional Information' },
];

interface Props {
  cs: CreditSubmission;
  value: LenderDeskingSections;
  isCSDecisionPosting: boolean;
  handleDecisionSave: (value: string) => void;
}

export const DecisionSection = ({ value, cs, isCSDecisionPosting, handleDecisionSave }: Props) => {
  const { control } = useFormContext<LenderDeskingPanelFormValues>();

  const decision = useWatch({ control: control, name: 'submission.decision' });

  const csDecision = useMemo(() => {
    if (!cs.decision) return null;
    return decisionCodeToStatus[cs.decision as keyof typeof decisionCodeToStatus]?.toString();
  }, [cs.decision]);

  return (
    <Stack
      gap="1rem"
      direction="row"
      alignItems="center"
      sx={{ padding: '1rem 1.5rem', border: `1px solid ${grey[300]}`, borderRadius: '0.25rem' }}
    >
      <Typography variant="h6" component="span">
        Decision
      </Typography>

      <Box sx={{ width: '20rem' }}>
        <SelectField
          control={control}
          variant="outlined"
          label="Decision Status"
          options={decisionOptions}
          name="submission.decision"
        />
      </Box>

      <RenderWithCondition condition={decision !== '803370003'}>
        <Button
          variant="contained"
          onClick={() => handleDecisionSave(decision!)}
          disabled={isCSDecisionPosting || decision === csDecision}
        >
          Save
        </Button>
      </RenderWithCondition>
    </Stack>
  );
};
